/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoModelsBoolResponse
 */
export interface EodMelcoModelsBoolResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EodMelcoModelsBoolResponse
     */
    result?: boolean;
}

export function EodMelcoModelsBoolResponseFromJSON(json: any): EodMelcoModelsBoolResponse {
    return EodMelcoModelsBoolResponseFromJSONTyped(json, false);
}

export function EodMelcoModelsBoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoModelsBoolResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function EodMelcoModelsBoolResponseToJSON(value?: EodMelcoModelsBoolResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}


